export default "__VITE_ASSET__D7dDkPjb__"